import React from 'react';
import AppBreadcrumbs from 'components/molecules/AppBreadcrumbs';
import { AppButton } from 'components';

export const formatDateTime = (value) =>
  value
    ? new Date(value).toLocaleDateString('en-IN', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    : '—';

export function DetailPageShell({
  title,
  links,
  current,
  status,
  statusClassName,
  subtitle,
  onBack,
  actions,
  children,
}) {
  return (
    <div className="mainWraper coursetabsection">
      <div className="tab">
        <div className="tab__content ___adjust___tab___padding">
          <div className="tab__content-actHead">
            <AppBreadcrumbs links={links} current={current} />
          </div>

          <div className="tab__content-actBody">
            <div className="px-4 px-md-5 py-4 py-md-5">
              <div className="d-flex align-items-start justify-content-between flex-wrap gap-3 border-bottom pb-4 mb-4">
                <div>
                  <div className="d-flex align-items-center flex-wrap gap-3 mb-2">
                    <h2 className="prime-head mb-0" style={{ fontSize: '2rem', fontWeight: 800 }}>
                      {title}
                    </h2>
                    {status ? (
                      <span
                        className={statusClassName}
                        style={{
                          fontSize: '0.95rem',
                          padding: '6px 18px',
                          fontWeight: 600,
                          borderRadius: '999px',
                          textTransform: 'capitalize',
                        }}
                      >
                        {status}
                      </span>
                    ) : null}
                  </div>
                  {subtitle ? (
                    <p className="mb-0 text-muted" style={{ fontSize: '1.1rem' }}>
                      {subtitle}
                    </p>
                  ) : null}
                </div>

                <div className="d-flex flex-wrap gap-2">
                  {actions}
                  <AppButton variantClass="btn btn-secondary" onClick={onBack}>
                    Back
                  </AppButton>
                </div>
              </div>

              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export function DetailSection({ title, children, actions }) {
  return (
    <div
      className="card mb-4 shadow-sm border-0"
      style={{ borderRadius: '12px', background: '#fff', border: '1px solid #eee' }}
    >
      <div
        className="card-header bg-white px-4 py-4 d-flex align-items-center justify-content-between flex-wrap gap-2"
        style={{ borderBottom: '1px solid #f1f3f5' }}
      >
        <h5 className="mb-0 fw-bold" style={{ color: '#7e1f8c', fontSize: '1.25rem' }}>
          {title}
        </h5>
        {actions}
      </div>
      <div className="card-body p-0">{children}</div>
    </div>
  );
}

export function DetailTable({ rows = [] }) {
  return (
    <div className="table-responsive">
      <table className="table table-sm tableWrap__table mb-0">
        <tbody>
          {rows.map((row) => (
            <tr key={row.label}>
              <th
                className="align-middle bg-light"
                style={{
                  width: '220px',
                  minWidth: '220px',
                  color: '#6c757d',
                  fontSize: '0.95rem',
                  fontWeight: 700,
                  borderTop: '1px solid #f1f3f5',
                  padding: '16px 20px',
                }}
              >
                {row.label}
              </th>
              <td
                className="align-middle"
                style={{
                  color: '#212529',
                  fontSize: '1rem',
                  borderTop: '1px solid #f1f3f5',
                  padding: '16px 20px',
                  whiteSpace: row.preserveWhitespace ? 'pre-wrap' : 'normal',
                  lineHeight: 1.6,
                }}
              >
                {row.value ?? '—'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function MissingDetailState({ links, current, message, onBack, backLabel }) {
  return (
    <div className="mainWraper coursetabsection">
      <div className="tab">
        <div className="tab__content ___adjust___tab___padding">
          <div className="tab__content-actHead">
            <AppBreadcrumbs links={links} current={current} />
          </div>

          <div className="tab__content-actBody">
            <div className="px-4 px-md-5 py-5">
              <div
                className="card shadow-sm border-0"
                style={{ borderRadius: '12px', border: '1px solid #eee' }}
              >
                <div className="card-body text-center py-5">
                  <p className="text-muted mb-4" style={{ fontSize: '1.05rem' }}>
                    {message}
                  </p>
                  <AppButton variantClass="btn btn-primary" onClick={onBack}>
                    {backLabel}
                  </AppButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
